import {QuantidadesModel} from './../content/pages/components/models/quantidades.model';
import {Injectable} from '@angular/core';
import {GenericServicesMotoristaService} from './generic-services-motorista.service';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';
import {ResumoMonitoramento} from '../content/pages/components/paineis/monitoramento-motorista/resumo-monitoramento.model';
import {ParametrosReenvioXML} from '../content/pages/components/shared/reenvio-xml';
import { Observable } from 'rxjs';
import { InfoEntregasAtrasadasMonitoramento } from '../content/pages/components/paineis/painel-gerencial/components/row-visao/components/dialog-info-entregas-atrasadas/model/info-entregas-atrasadas-monitoramento';
import { map } from 'rxjs/operators';
import {DadosGraficoEntrega} from '../content/pages/components/paineis/nivel-servico-logistico/modelo.model';

@Injectable({providedIn: 'root'})
export class EntregasService extends GenericServicesMotoristaService {

	constructor(private _mensagensService: MensagensService,
				private _httpClient: HttpClient) {
		super();
	}

	getMensagensService(): MensagensService {
		return this._mensagensService;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}

	getUrlRecurso(): string {
		return '/entregas';
	}

	getInformacoes(idEntrega) {
		return this.get('/informacoes', {
			dados: {
				id: idEntrega
			}
		});
	}

	getInformacoesEntregas(idsEntregas, situacao) {
		return this.get('/informacoesEntregas', {
			dados: {
				entregas: idsEntregas,
				situacao
			}
		});
	}

	detalhar(id) {
		return this.get<any>('/detalhar', {dados: {id: id}});
	}

	getUltimaEntregaMotorista(id) {
		return this.get<any>('/ultimaEntregaMotorista', {dados: {idMotorista: id}});
	}

	getGraficoEntrega(filtros: any): Observable<DadosGraficoEntrega> {
		return this.post(`/grafico`, {
			dados: filtros
		});
	}

	getQuantidadesEntregas(filtros: any) {
		return this.get<QuantidadesModel>('/quantidadesPorTipo', {
			dados: filtros,
			exibirLoading: false,
		});
	}

	getMapaEntregas(filtros: {
		data: any;
		vincularLinhaVerde: boolean;
		motoristas: any;
	}) {
		return this.get('/mapaEntregas', {dados: filtros});
	}

	resumoAtualEntregasMotorista(filtro: {idsMotoristas: string[], idsFiliais: string[], idsVeiculos: string[]}) {
		return this.post<ResumoMonitoramento>('/resumoAtualEntregasMotorista', { dados: filtro });
	}

	reenviarXml(dados: ParametrosReenvioXML): any {
		return this.post('/reenviarXML', {
			dados: dados
		});
	}

	salvarReagendamentoEntrega(id: any) {
		return this.post('/salvarReagendamentoEntrega', {
			dados: {
				idEntrega: id
			},
			enviarComoQueryString: true
		});
	}

	getMotivoReagendamento(idEntrega: any) {
		return this.get('/motivoReagendamento', {
			dados: {
				idEntrega: idEntrega
			}
		});
	}

	alterarImagem(imagemCanhoto) {
		return this.post(`/editar-canhoto`, {
			dados: imagemCanhoto,
			enviarComoQueryString: false
		});
	}

	salvarImagem(imagemCanhoto) {
		return this.post<any>(`/adicionar-canhoto`, {
			dados: imagemCanhoto,
			enviarComoQueryString: false
		});
	}

	salvarImagemEntrega(imagemEntrega) {
		return this.post<any>(`/adicionar-entrega`, {
			dados: imagemEntrega,
			enviarComoQueryString: false
		});
	}

	mudarSituacaoEntrega(id: number, novaSituacao: string) {
		return this.put(`/mudarSituacaoEntrega`, {
				dados: {
					idEntrega: id,
					novaSituacao: novaSituacao
				},
				exibirLoading: true,
				enviarComoQueryString: true
		    }
		);
	}
	obterEntregasAtrasadasPorCarregamentos(idsCarregamentos: string[], query: string): Observable<InfoEntregasAtrasadasMonitoramento[]> {
		return this.post<InfoEntregasAtrasadasMonitoramento[]>(`/entregasAtrasadasPorCarregamentos?${query}`, {
			dados: idsCarregamentos,
			exibirLoading: false,
		});
	}

	pesquisarVolume(dados: any, query: string) {
		return this.post<any>(`/pesquisarVolumeEntrega?${query}`, { dados }).pipe(
			map(response => {
				return response;
			})
		);
	}

    listarEntregasPaginadas(filtro: any, query: string) {
		return this.post<any>(`/listarEntregasPaginadas?${query}`, {
			dados: filtro
		});
    }

	gerarRelatorioEntregasListagem(filtro) {
		return this.post<any>(`/gerarRelatorioListagemEntregas`, {
			dados: filtro
		});
	}

	editarEntregaPorAtributo(idEntrega: number, atributo: string, valor: Date) {
		return this.put(`/editarEntregaPorAtributo`, {
			dados: {
				idEntrega: idEntrega,
				atributo: atributo,
				valor: valor
			},
			enviarComoQueryString: true
		});
	}
}
